"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _misc = _interopRequireDefault(require("../tokens/misc"));
var _black = _interopRequireDefault(require("../tokens/color/black"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var defaultHeight = "max-content";
var defaultLineHeight = "1.2rem";
var Tag = function Tag(_ref) {
  var type = _ref.type,
    label = _ref.label,
    bgColor = _ref.bgColor,
    textColor = _ref.textColor,
    tagWidth = _ref.tagWidth,
    fontSize = _ref.fontSize;
  return /*#__PURE__*/_react["default"].createElement(Tag.Wrapper, {
    type: type,
    bgColor: bgColor,
    textColor: textColor,
    tagWidth: tagWidth,
    fontSize: fontSize
  }, label);
};
var heights = {
  tag: defaultHeight,
  rating: "3rem"
};
var widths = function widths(tagWidth) {
  return {
    tag: tagWidth,
    rating: "4.4rem"
  };
};
var fontSizes = function fontSizes(fontSize) {
  return {
    tag: fontSize,
    rating: "2rem"
  };
};
var lineHeights = {
  tag: defaultHeight,
  rating: "2.9rem"
};
var borders = {
  tag: "none",
  rating: "none"
};
var getHeight = function getHeight(type) {
  return heights[type] || defaultHeight;
};
var getWidth = function getWidth(type, tagWidth) {
  return widths(tagWidth)[type];
};
var getFontSize = function getFontSize(type, fontSize) {
  return fontSizes(fontSize)[type];
};
var getLineHeight = function getLineHeight(type) {
  return lineHeights[type] || defaultLineHeight;
};
var getBorder = function getBorder(type) {
  return borders[type] || "none";
};
var getBackground = function getBackground(props) {
  if (props.bgColor) {
    return props.bgColor;
  } else {
    return "transparent";
  }
};
Tag.propTypes = {
  type: _propTypes["default"].oneOf(["tag", "rating"]),
  label: _propTypes["default"].string,
  bgColor: _propTypes["default"].string,
  textColor: _propTypes["default"].string,
  tagWidth: _propTypes["default"].string,
  fontSize: _propTypes["default"].string
};
Tag.defaultProps = {
  type: "tag",
  label: "",
  bgColor: "",
  textColor: _black["default"],
  tagWidth: "max-content",
  fontSize: "1.2rem"
};
Tag.Wrapper = _styledComponents["default"].div.withConfig({
  componentId: "sc-2gamf4-0"
})(["height:", ";width:", ";background:", ";display:flex;align-items:center;justify-content:center;border-radius:", ";color:", ";font-size:", ";line-height:", ";border:", ";", ""], function (props) {
  return getHeight(props.type);
}, function (props) {
  return getWidth(props.type, props.tagWidth);
}, function (props) {
  return getBackground(props);
}, function (props) {
  return props.type == "tag" ? "4px" : _misc["default"].radius;
}, function (props) {
  return props.textColor;
}, function (props) {
  return getFontSize(props.type, props.fontSize);
}, function (props) {
  return getLineHeight(props.type);
}, function (props) {
  return getBorder(props.type);
}, function (props) {
  return props.type == "tag" && (0, _styledComponents.css)(["padding:0.2rem 0.5rem 0.2rem;"]);
});
var _default = exports["default"] = Tag;